import React from "react";
import Checkbox from "../Checkbox";
import RadioGroup from "../RadioGroup";
import Info from "../../assets/icons/ic_info.svg";
import { YES_NO_OPTIONS } from "components/userForms/constants";

const ConsentsAgreements = ({ formData, handleChange, formErrors }) => {
  return (
    <div>
      <h3 className="text-lg md:text-base font-semibold">
        Photographic Consent
      </h3>

      <RadioGroup
        label="Do you give photographic consent for images and videos to be used on social media and promotional materials?"
        name="photographicConsent"
        options={YES_NO_OPTIONS}
        selectedValue={formData.photographicConsent}
        onChange={handleChange}
        error={formErrors.photographicConsent}
        required
      />

      <h3 className="text-lg md:text-base font-semibold pt-2">
        Data Processing & Conduct Agreement
      </h3>
      <div className="flex items-start mt-2 gap-2">
        <Checkbox
          className="text-xs"
          name="agreeTermsConditions"
          checked={formData.agreeTermsConditions === "yes"}
          onChange={(e) =>
            handleChange({
              target: {
                name: "agreeTermsConditions",
                value: e.target.checked ? "yes" : "no",
              },
            })
          }
          label={
            <span className="whitespace-normal">
              I agree to my data being processed to support all activities and
              to respect the philosophy of the Seventh-day Adventist Church
              whilst attending this event
            </span>
          }
          required
        />
      </div>

      {formErrors.agreeTermsConditions && (
        <div className="flex gap-1 w-fit text-[10px] bg-red-100 text-red-600 mt-1 rounded p-[3px]">
          <img src={Info} alt="info" />
          {formErrors.agreeTermsConditions}
        </div>
      )}
    </div>
  );
};

export default ConsentsAgreements;
